<template>
  <div class="page">
    <!-- Content Section and Navigation Together -->
    <div class="content-wrapper">
      <!-- Content Section -->
      <div class="content-section">
        <div v-for="(item, index) in content.Items" :key="index" class="content-item">
          <div class="card">  
            <div class="card-body">
              <h1 class="title">{{ item.title }}</h1>
              <div v-html="formattedDescriptionNo(item.description_no_1)" class="description_no"></div> 
              <div class="card-header">
                <img :src="item.image_1" alt="Content Image" class="image" />
              </div>  
              <div v-html="formattedDescriptionNo(item.description_1)" class="description"></div> 
            </div>
          </div>
        </div>
      </div>
  </div>
      <!-- Contact Section (moved to the right) -->
      <!-- <div class="contact-container">
        <h2>Contact Information</h2>
        <div class="contact-info">
          <i class="fas fa-phone"></i>
          <p>Phone: +86 19883038871</p>
        </div>
        <div class="contact-info">
          <i class="fas fa-envelope"></i>
          <p>Email: dankao.chen@nxtech.pub</p>
        </div>
      </div> -->
    </div>

</template>

<style src="@/assets/css/news.css" scoped></style>

<script>
import { mapState } from "vuex";
export default {
  data() {
    return {
      cn: {
        Items: [
          {
            id: 1,
            image_1: require("@/assets/img/News/004/LightShowPageimg1.png"),
            title:
              "象山影视城“唐宋奇妙夜”文化夜游活动火爆开启，云翰虹章助力文旅新体验",
            description_no_1:`
            `,
            description_1:`
               2023年7月，为期三个多月的“唐宋奇妙夜”文化夜游活动在象山影视城正式开启。该活动一经推出便取得了极高的热度，无数游客慕名而来，游览名景点打卡和分享。

               象山影视城位于浙江省宁波市象山县，曾获2017年度旅游景区人气奖，并被评为国家4A级景区。自2005年开城以来，象山影视城先后拍摄了1500多部影视作品，其中不乏《神雕侠侣》等知名影视剧。本次“唐宋奇妙夜”由象山影视城推出，并由云翰虹章提供相关的技术服务。

               在“唐宋奇妙夜”活动中，每晚19：00-20：00在襄阳城景点准时演出的古城墙灯光投影秀广受追捧，单日人流量最高达到5.5万人。该灯光投影秀分为舞蹈编排与城墙投影两个部分，其中城墙投影部分采用了基于虚幻引擎的超写实CG动画制作，并由云翰虹章提供技术支持。此次灯光投影秀结合了传统的舞蹈表演与投影技术，展示了象山影视城制作的一系列知名影视剧（如：《琅琊榜》《庆余年》）中的经典场面，为观众带来了新奇的视听体验。 

               作为此次活动的重要技术支持方，我们非常荣幸能够参与到这一项目中，并展示我们的技术实力与创意。未来，云翰虹章将继续与象山影视城携手，共同探索文化旅游领域的新内容，为观众带来更多精彩的视听体验。
            `,
          },
          // Add more items as needed
        ],
      },
      en: {
        Items: [
          {
            id: 2,
            image_1: require("@/assets/img/News/004/LightShowPageimg1.png"),
            title:
              "'Wonderful Night of the Tang and Song Dynasties' cultural night tour activities opened hot, a brand new experience of cultural travel supported by Rosy Nebula",
              description_no_1:`
            `,
              description_1:`
               In July 2023, the cultural night activity, "Wonderful Night of the Tang and Song Dynasties", lasting for over three months, was opened in Xiangshan Global Studios. The tour has quietly gained popularity since its launch, with many tourists coming to Xiangshan and sharing their travel experiences. 

               Xiangshan Global Studios, an AAAA National Tourist Attraction in China, is in Xiangshan County, Ningbo City, Zhejiang Province. It received the Annual Tourist Attraction Popularity Award in 2017. Since 2005, more than 1500 film and television works have been produced there, including famous works like "The Return of the Condor Heroes". The "Wonderful Night of the Tang and Song Dynasties" was launched by Xiangshan Global Studios, with Rosy Nebula providing relevant technical services.

               In this activity, the light projection shown on the ancient city wall performed in Xiangyang City from 19:00 to 20:00 every night was widespread, with the maximum number of people in a single day reaching 55,000. The show included dancing performances and light projections made using hyperrealistic CG animation based on Unreal Engine. The light projection was provided by Rosy Nebula. The light projection used traditional dance performances and shadow casting techniques and the content was a classic fragment about some famous film and television works made by Xiangshan Global Studios, like "Nirvana in Fire" and "Joy of Life". 

               As the technical backer of this activity, we are honoured to join this project and showcase our technology and creativity. In the future, Rosy Nebula will continue to collaborate with Xiangshan Film and Television City to jointly explore new content in the field of cultural tourism to bring more exciting audiovisual experiences to the audience.`,
          },
          // Add more items as needed
        ],
      },
    };
  },
  methods: {
    formattedDescription(description) {
      // Apply additional formatting if needed
      return description.replace(/\n\s*\n/g, '<br /><br />'); // Convert double newlines to paragraph breaks
    },
    formattedDescriptionNo(description_no) {
      // Apply additional formatting if needed
      return description_no.replace(/\n\s*\n/g, '<br /><br />'); // Convert double newlines to paragraph breaks
    },
  },
  mixins: [],
  computed: {
    ...mapState(["language"]),
    content() {
      const defaultContent = { title: "", industry_areas: [] };
      const currentLanguage = this.language === "en" ? this.en : this.cn;
      console.log("Current Language:", currentLanguage); // Debug statement
      return currentLanguage || defaultContent;
    },
  },
  watch: {
    language(newValue) {
      console.log("Language changed to:", newValue); // Debug statement
      this.$forceUpdate(); // Force the component to re-render when the language changes
    },
  },
};
</script>
